import type {
  AvailableDevice,
  IAccessControlRepository,
  QRTokenResponse,
  RemoteOpenRequest,
  RemoteOpenResponse,
  ValidatePlateRequest,
  ValidatePlateResponse,
  ValidateQRRequest,
  ValidateQRResponse,
} from '@yawi/domain';
import { getApiClient } from '../../http/apiClient';

export class ApiAccessControlRepository implements IAccessControlRepository {
  async generateResidentQR(): Promise<QRTokenResponse> {
    const client = getApiClient();
    return await client.get<QRTokenResponse>('v1/access-control/qr/my');
  }

  async validateQR(request: ValidateQRRequest): Promise<ValidateQRResponse> {
    const client = getApiClient();
    return await client.post<ValidateQRResponse>('v1/access-control/validate/qr', request);
  }

  async validatePlate(request: ValidatePlateRequest): Promise<ValidatePlateResponse> {
    const client = getApiClient();
    return await client.post<ValidatePlateResponse>('v1/access-control/validate/plate', request);
  }

  async getAvailableDevices(): Promise<AvailableDevice[]> {
    const client = getApiClient();
    return await client.get<AvailableDevice[]>('v1/access-control/devices/available');
  }

  async remoteOpen(request: RemoteOpenRequest): Promise<RemoteOpenResponse> {
    const client = getApiClient();
    return await client.post<RemoteOpenResponse>('v1/access-control/remote-open', request);
  }
}

